<section class="fj-contact-desk fj-contact-form-first" appHeroScrollCue>
    <div class="site-container fj-contact-desk-grid">
        <aside class="fj-hero-form" aria-label="Inspection request form">
            <app-contact-form></app-contact-form>
        </aside>
    </div>
</section>

<section class="fj-contact-ribbon" aria-label="GTX contact methods">
    <div class="site-container">
        <a href="tel:512-848-1316">
            <span>Fastest path</span>
            <strong>Call or text</strong>
            <small>(512) 848-1316</small>
        </a>
        <a href="mailto:moreno@gtxinspections.com">
            <span>Send details</span>
            <strong>Email</strong>
            <small>moreno&#64;gtxinspections.com</small>
        </a>
        <article>
            <span>Office hours</span>
            <strong>8:00 am - 8:00 pm</strong>
            <small>Monday-Friday and Sunday / Saturday closed</small>
        </article>
    </div>
</section>
